var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "209px",
    height: "210px",
    viewBox: "0 0 209 210",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Help Scout logo square blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.7911078,39.3226496 L8.21891669,78.6452973 C3.52239487,73.7299657 0.587067671,66.9713832 3.55271368e-15,58.9839747 C3.55271368e-15,51.6109741 3.52239346,44.2379788 8.21891669,39.3226496 L46.3781703,0 C51.074695,4.91533064 54.0100222,12.2883274 54.0100222,19.661324 C54.0100222,27.0343223 50.4876325,34.4073175 45.7911078,39.3226496 Z M62.3192539,93.7693871 L100.304322,54.4467443 C105.052462,59.9764888 108.020046,66.7350709 108.020046,74.1080774 C108.020046,81.4810721 104.458944,88.8540669 99.7108139,93.7693988 L61.7257402,133.092042 C56.9776058,128.176704 54.0100222,120.803715 54.0100222,113.430714 C54.0100222,106.057714 57.571119,98.6847128 62.3192539,93.7693871 Z M61.3884346,39.322639 L72.6036339,27.8283265 L100.346497,0 C105.06868,4.83970997 108.020047,12.0992757 108.020047,19.3588415 C108.020047,26.6184087 104.478404,33.8779731 99.7562208,38.7176845 L72.6036392,66.5460181 L61.3884399,78.0403331 L45.4510577,94.3743548 L34.235859,105.868664 L7.67355327,133.092035 C2.9513673,128.252317 -1.42108547e-14,120.992759 -1.42108547e-14,113.733189 C-1.42108547e-14,106.473619 3.54164159,99.2140488 8.26382903,94.3743433 L34.8261347,67.1509728 L45.4510524,55.6566626 L61.3884346,39.322639 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visual-Elements-/-Logos",
    transform: "translate(-898.000000, -2033.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Help-Scout-logo-square-blue",
    transform: "translate(898.000000, 2033.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors/Blue/500",
    fill: "#1292EE"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Swatch",
    x: 0,
    y: 0,
    width: 209,
    height: 210
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logos/1.-Help-Scout/Mark",
    transform: "translate(51.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color-Mask"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/_Default/White",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Swatch",
    x: 0,
    y: 0,
    width: 107.966774,
    height: 132.959082
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.577db93dab9d08cd8b7937584dce3fcb.svg";
export { ForwardRef as ReactComponent };